export default __webpack_public_path__ + "static/media/unsere_haeuser_web-xs@2x.9e7656a1.webp";